<template>
  <div v-if="photo">
    <v-container :style="{ 'background-color': color }" fluid class="pa-0">
      <v-row
        id="photoWrapper"
        :class="photoExpanded ? 'expanded' : ''"
        :style="{ 'background-color': color }"
        no-gutters
        align="center"
        justify="center"
        class="photo-wrapper ma-0"
      >
        <v-col class="fill-height pa-0" cols="12">
          <div
            :class="isMobileOrTablet ? 'is-mobile-or-tablet' : ''"
            class="fill-height photo-container"
          >
            <template
              v-if="
                (!me && !photo.isNude) ||
                  (me && !me.isNudeFilterActive && photo.isNude) ||
                  !photo.isNude ||
                  showPhoto
              "
            >
              <v-zoomer
                ref="zoomer"
                :zoomed.sync="zoomed"
                :limit-translation="false"
                :mouse-wheel-to-zoom="zoomed"
                :max-scale="6"
                style="width: 100%; height: 100%;"
              >
                <v-img
                  :src="$asa.getImageUrl(photo, zoomed ? 'zoom' : 'full')"
                  :lazy-src="$asa.getImageUrl(photo, zoomed ? 'full' : 'thumb')"
                  :alt="`Photo by ${photo.photographerName}`"
                  :draggable="false"
                  :contain="true"
                  :height="isMobileOrTablet ? '100%' : wrapperHeight > photo.height ? photo.height : wrapperHeight"
                  class="align-self-center"
                  @click.right.stop.prevent="onRightClick"
                  @loadstart="imageStartLoading"
                  @load="imageLoaded"
                >
                  <div v-if="imageLoading" class="h-100-percentage d-flex align-center justify-center">
                    <v-icon :small="zoomed" color="white">fal fa-spinner fa-spin</v-icon>
                  </div>
                </v-img>
              </v-zoomer>
            </template>
            <div v-else class="text-center white--text">
              <h4 class="text-h6 mb-4">NSFW Content</h4>
              <p>
                This content is for mature audiences only.<br />
                User discretion is advised.
              </p>
              <v-btn depressed secondary @click="showNSFWContent()">
                Show photo
              </v-btn>
            </div>
          </div>
        </v-col>
        <v-hover>
          <div
            slot-scope="{ hover }"
            class="top-actions-mask mask-left"
            @click="goBack()"
          >
            <v-btn
              :light="color === '#FFFFFF'"
              :dark="color !== '#FFFFFF'"
              :input-value="hover"
              :class="{ transparent: !hover, 'hide-action-btn': mouseStopped }"
              class="my-2 ml-2 close-btn"
              absolute
              fab
              small
              depressed
            >
              <v-icon dark small>fal fa-times</v-icon>
            </v-btn>
          </div>
        </v-hover>
        <v-hover v-if="!zoomed">
          <div
            slot-scope="{ hover }"
            class="top-actions-mask mask-right"
            @click="toggleExpand()"
          >
            <v-btn
              :light="color === '#FFFFFF'"
              :dark="color !== '#FFFFFF'"
              :input-value="hover"
              :class="{ transparent: !hover, 'hide-action-btn': mouseStopped }"
              class="my-2 mr-2 fullscreen-btn"
              absolute
              fab
              small
              depressed
            >
              <v-icon dark small>fal fa-expand-arrows</v-icon>
            </v-btn>
          </div>
        </v-hover>
        <v-hover
          v-if="
            !zoomed &&
              sorround.previousPhotoId &&
              queryFrom !== 'home' &&
              queryFrom !== 'leaderboard' &&
              queryFrom !== 'feeds'
          "
        >
          <div
            slot-scope="{ hover }"
            class="navigation-mask mask-left"
            @click.right.stop.prevent="onRightClick"
            @click="
              goTo(
                `/photo/${sorround.previousPhotoId}/${
                  sorround.previousPhotoSlug
                }${getQueries()}`
              )
            "
          >
            <v-btn
              :input-value="hover"
              :light="color === '#FFFFFF'"
              :dark="color !== '#FFFFFF'"
              :to="
                `/photo/${sorround.previousPhotoId}/${
                  sorround.previousPhotoSlug
                }${getQueries()}`
              "
              :class="{ transparent: !hover, 'hide-action-btn': mouseStopped }"
              class="ml-2 prev-btn"
              small
              absolute
              fab
              depressed
              nuxt
            >
              <v-icon small dark class="d-inline-flex"
                >fal fa-angle-left</v-icon
              >
            </v-btn>
          </div>
        </v-hover>
        <v-hover
          v-if="
            !zoomed &&
              sorround.nextPhotoId &&
              queryFrom !== 'home' &&
              queryFrom !== 'leaderboard' &&
              queryFrom !== 'feeds'
          "
        >
          <div
            slot-scope="{ hover }"
            class="navigation-mask mask-right"
            @click.right.stop.prevent="onRightClick"
            @click="
              goTo(
                `/photo/${sorround.nextPhotoId}/${
                  sorround.nextPhotoSlug
                }${getQueries()}`
              )
            "
          >
            <v-btn
              v-if="
                sorround.nextPhotoId &&
                  queryFrom !== 'home' &&
                  queryFrom !== 'leaderboard' &&
                  queryFrom !== 'feeds'
              "
              :input-value="hover"
              :light="color === '#FFFFFF'"
              :dark="color !== '#FFFFFF'"
              :to="
                `/photo/${sorround.nextPhotoId}/${
                  sorround.nextPhotoSlug
                }${getQueries()}`
              "
              :class="{ transparent: !hover, 'hide-action-btn': mouseStopped }"
              class="mr-2 next-btn"
              absolute
              fab
              small
              depressed
              nuxt
            >
              <v-icon small dark class="d-inline-flex"
                >fal fa-angle-right</v-icon
              >
            </v-btn>
          </div>
        </v-hover>
        <v-hover>
          <div slot-scope="{ hover }" @click="toggleZoomer">
            <v-tooltip top>
              <template #activator="{ on }">
                <v-btn
                  :light="color === '#FFFFFF'"
                  :dark="color !== '#FFFFFF'"
                  :input-value="hover"
                  :class="{
                    transparent: !hover,
                    'hide-action-btn': mouseStopped
                  }"
                  class="my-2 mr-2 zoom-btn"
                  absolute
                  fab
                  small
                  depressed
                  v-on="on"
                >
                  <v-icon dark small>
                    fal fa-search-{{ zoomed ? 'minus' : 'plus' }}
                  </v-icon>
                </v-btn>
              </template>
              <span>
                Toggle Zoom and drag the image
              </span>
            </v-tooltip>
          </div>
        </v-hover>
        <v-menu top offset-y>
          <template #activator="{ on: menu }">
            <v-tooltip right>
              <template #activator="{ on: tooltip }">
                <v-btn
                  :light="color === '#FFFFFF'"
                  :dark="color !== '#FFFFFF'"
                  :class="{ 'hide-action-btn': mouseStopped }"
                  class="transparent my-2 ml-2 color-btn"
                  absolute
                  fab
                  small
                  depressed
                  v-on="{ ...menu, ...tooltip }"
                >
                  <v-icon dark x-small>fal fa-tint</v-icon>
                </v-btn>
              </template>
              <span>
                Change background colour
              </span>
            </v-tooltip>
          </template>
          <v-list>
            <v-list-item
              v-for="(c, i) in colors"
              :key="i"
              @click="updateColor(c)"
            >
              <v-list-item-title>
                <v-avatar
                  :color="c"
                  :size="20"
                  :class="{ bordered: c === '#FFFFFF' }"
                ></v-avatar>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-row>
    </v-container>
    <v-dialog v-model="zoomDialog" max-width="400">
      <v-card outlined>
        <v-card-text class="pt-4">
          <p class="text-body-2">
            Digital zoom might reduce the image resolution and the image quality.
          </p>
          <p class="mb-0 text-body-2">
            Use mousewheel to increase / decrease the zoom.
            Double click on the image to reset its position.
          </p>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text small @click="zoomDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import moment from 'moment'
import { mapState } from 'vuex'
import types from '@/utils/types'
import { EventBus } from '@/plugins/event-bus'

export default {
  name: 'PhotoView',
  props: {
    me: {
      type: [Object, Boolean],
      default: () => {}
    },
    photo: {
      type: Object,
      default: () => {}
    },
    sorround: {
      type: Object,
      default: () => {}
    },
    goBack: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      queryFrom: this.$route.query.from,
      showPhoto: false,
      colors: ['#000000', '#CCCCCC', '#FFFFFF'],
      containerHeight: 0,
      mouseStopped: true,
      timedelay: 1,
      delay: setInterval(this.delayCheck, 500),
      mounted: false,
      zoomed: false,
      zoomDialog: false,
      allowKeyboardNavigation: true,
      imageLoading: false
    }
  },
  computed: {
    ...mapState({
      photoExpanded: state => state.photos.photoExpanded,
      color: state => state.photos.color,
      zoomDateTime: state => state.photos.zoomDateTime
    }),
    isMobileOrTablet() {
      return this.$vuetify.breakpoint.xsOnly
    },
    wrapperHeight() {
      if (!this.mounted) return
      const height = this.containerHeight
      return height
    }
  },
  watch: {
    zoomed(val) {
      if (
        val &&
        (!this.zoomDateTime ||
          moment().isAfter(moment(this.zoomDateTime).add(1, 'h')))
      ) {
        this.zoomDialog = true
        this.$store.dispatch('photos/setZoomDateTime')
      }
    }
  },
  mounted() {
    this.mounted = true
    this.$nextTick(function() {
      this.handleResize()
      window.addEventListener('resize', debounce(this.handleResize, 150))
    })
    document.addEventListener('wheel', this.exitExpandFromWheel)
    document.addEventListener('mousemove', this.showActionBtns)
    document.addEventListener('keydown', this.handleKeyboardSorround)
    EventBus.$on(
      'set-allow-keyboard-navigation',
      value => (this.allowKeyboardNavigation = value)
    )
    const el = document.getElementsByClassName('zoomer')[0]
    el.className += ' d-flex'
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    document.removeEventListener('keydown', this.handleKeyboardSorround)
  },
  methods: {
    handleKeyboardSorround(e) {
      if (this.allowKeyboardNavigation) {
        this.$store.dispatch('account/setCurationDialog', {
          visible: false
        })
        if (e.keyCode === 39 && this.sorround.nextPhotoId) {
          this.goTo(
            `/photo/${this.sorround.nextPhotoId}/${
              this.sorround.nextPhotoSlug
            }${this.getQueries()}`
          )
        }
        if (e.keyCode === 37 && this.sorround.previousPhotoId) {
          this.goTo(
            `/photo/${this.sorround.previousPhotoId}/${
              this.sorround.previousPhotoSlug
            }${this.getQueries()}`
          )
        }
      }
    },
    handleResize() {
      const el = document.getElementById('photoWrapper')
      if (el) {
        this.containerHeight = el.offsetHeight - (this.photoExpanded ? 40 : 120)
      }
    },
    showActionBtns() {
      this.mouseStopped = false
      this.timedelay = 1
      clearInterval(this.delay)
      this.delay = setInterval(this.delayCheck, 500)
    },
    delayCheck() {
      if (this.timedelay === 3) {
        this.mouseStopped = true
        this.timedelay = 1
      }
      this.timedelay = this.timedelay + 1
    },
    showNSFWContent() {
      this.showPhoto = true
    },
    onRightClick() {
      let text = 'This photo is © of '
      text +=
        this.photo.statusName === types.photo.status.inCuration
          ? 'the photographer'
          : this.photo.photographerName
      EventBus.$emit('snackbar', {
        text,
        color: 'info'
      })
    },
    getQueries() {
      const q = this.$route.query
      let query = `?from=${q.from}`
      if (q.t) query += `&t=${q.t}`
      if (q.st) query += `&t=${q.st}`
      if (q.status) query += `&status=${q.status}`
      if (q.user || q.pid) query += `&user=${q.user || q.pid}`
      if (q.exclude) query += `&exclude=${q.exclude}`
      if (q.curated) query += `&curated=${q.curated}`
      if (q.category) query += `&category=${q.category}`
      if (q.tags) query += `&tags=${q.tags}`
      if (q.sort) query += `&sort=${q.sort}`
      if (q.popularity) query += `&popularity=${q.popularity}`
      if (q.gid) query += `&gid=${q.gid}`
      if (q.aid) query += `&aid=${q.aid}`
      return query
    },
    async toggleExpand() {
      await this.$store.dispatch('photos/toggleExpander', !this.photoExpanded)
      await this.handleResize()
      // this.$ga.event({
      //   eventCategory: 'tracking',
      //   eventAction: 'actions',
      //   eventLabel: 'expand photo',
      //   eventValue: true
      // })
    },
    async exitExpandFromWheel() {
      if (this.photoExpanded) {
        await this.$store.dispatch('photos/toggleExpander', false)
      }
      await this.handleResize()
    },
    goTo(path) {
      this.$router.push(path)
    },
    updateColor(hex) {
      this.$store.dispatch('photos/updateColor', hex)
      // this.$ga.event({
      //   eventCategory: 'tracking',
      //   eventAction: 'actions',
      //   eventLabel: 'update color',
      //   eventValue: true
      // })
    },
    toggleZoomer() {
      this.zoomed ? this.$refs.zoomer.reset() : this.$refs.zoomer.zoomIn()
    },
    imageStartLoading() {
      this.imageLoading = true
    },
    imageLoaded() {
      this.imageLoading = false
    }
  }
}
</script>

<style scoped>
.photo-wrapper {
  height: 92vh;
  position: relative;
}
.photo-wrapper.expanded {
  height: 100vh;
}
.photo-wrapper.expanded .photo-container {
  padding: 0 70px;
}
.photo-wrapper.black {
  background-color: #212121;
}
.photo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px;
  position: relative;
}
.photo-container.is-mobile-or-tablet {
  padding: 0;
}
.photo-container img {
  display: block;
  max-width: 100%;
  max-height: calc(92vh - 120px);
}
.close-btn {
  top: 0;
  left: 0;
}
.fullscreen-btn {
  top: 0;
  right: 0;
}
.prev-btn {
  left: 0;
}
.next-btn {
  right: 0;
}
.color-btn {
  left: 0;
  bottom: 0;
}
.zoom-btn {
  right: 0;
  bottom: 0;
}
.bordered {
  border: 1px solid #cccccc !important;
}
.top-actions-mask {
  align-items: center;
  cursor: pointer;
  display: flex;
  position: absolute;
  top: 0;
  width: 50%;
  height: 60px;
}
.top-actions-mask.mask-left {
  left: 0;
}
.top-actions-mask.mask-right {
  right: 0;
}
.navigation-mask {
  align-items: center;
  cursor: pointer;
  display: flex;
  position: absolute;
  top: 60px;
  width: 33%;
  height: calc(100% - 120px);
}
.navigation-mask.mask-left {
  left: 0;
}
.navigation-mask.mask-right {
  right: 0;
}
.hide-action-btn {
  opacity: 0;
}
.fill-height {
  height: inherit;
}
.zoomer {
  display: flex !important;
}
@media only screen and (max-width: 600px), (max-device-width: 600px) {
  .photo-wrapper.expanded .photo-container {
    padding: 0;
  }
  .navigation-mask {
    width: 25px;
  }
}
</style>
